<template>
    <div id="main_wrap">
        <TheHeader />
            <main>
                <section class="main">
                    <video
                        class="bg-video"
                        autoplay
                        muted
                        loop
                        playsinline
                        >
                        <source src="@/assets/main.mp4" type="video/mp4" />
                    </video>
                    <div class="overlay"></div>
                    <h2>Engineering Energy <br>for a Sustainable Tomorrow</h2>
                </section>

                <section class="section section1">
                    <div class="inner_main ptb100">
                        <h2>"Business Overview"</h2>
                        <div class="tab-wrap">
                            <div class="tab-menu">
                                <button
                                    :class="{ active: activeTab === 1 }"
                                    @click="activeTab = 1"
                                >
                                    디지털 설계 본부
                                </button>

                                <button
                                    :class="{ active: activeTab === 2 }"
                                    @click="activeTab = 2"
                                >
                                    에너지 융합 시스템 본부
                                </button>
                            </div>

                            <div class="tab-content">
                                <div class="boxs_flx" v-if="activeTab === 1">
                                    <div class="boxs_row left">
                                        <div class="box img">
                                            <img src="@/assets/busi_01.jpg" alt="">
                                        </div>
                                        <div class="box text">
                                            <span>에너지 융합 시스템 본부</span>
                                            <h3>디지털 BIM기반 제로에너지건축물<br> 설계·정보 공유 플랫폼</h3>
                                            <p>에너지건축물(ZEB) 전 주기에서 플랫폼 참여자에게 사업개발 지원, 협업 구축, 공동 사업 매칭 등 핵심 공유 서비스를 제공합니다.<br><br>
                                                 개방형 인프라와 정보 유통 체계를 체계적으로 구축하여 신뢰성  있는 정보 공유 플랫폼을 운영하고 있습니다.</p>
                                        </div>
                                    </div>
                                    <div class="boxs_row right">
                                        <div class="box text">
                                            <span>Digital Twin & BIM-Powered BIPV Design Engineering</span>
                                            <h3>디지털 트윈 기반 BIM 태양광·BIPV<br> 엔지니어링 설계</h3>
                                            <p>디지털 트윈 기반 BIM 설계를 통해 설계 단계에서 발생할 수 있는 요소 간 충돌을 사전에 검토하여 시공 리스크를 최소화합니다.<br> <br>
                                                건물형(BIPV), 산업단지형, 영농형, 주차장형 등 다양한 태양광 적용 대상지에 대해 입지 적합성과 설치 가능 범위를 정밀 분석하고, 
                                                발전 효율을 극대화하는 최적의 에너지 시스템 아키텍처를 제안합니다.</p>
                                        </div>
                                        <div class="box img">
                                            <img src="@/assets/busi_02.jpg" alt="">
                                        </div>
                                    </div>
                                    <div class="boxs_row left">
                                        <div class="box img">
                                            <img src="@/assets/busi_03.jpg" alt="">
                                        </div>
                                        <div class="box text">
                                            <span>AI-Powered Energy Performance Optimization & Advanced Precision Simulation</span>
                                            <h3>AI기반 에너지 성능 예측 최적화·고정밀 시뮬레이션</h3>
                                            <p>에너지 효율과 일조 조건 등 다양한 AI시뮬레이션을 통해 과학적이고 효율적인 설계 서비스를 제공합니다. <br><br>
                                                설치 위치·방위·각도·규모에 따른 예상 발전량을 분석하고, 현장 환경을 반영한 성능 검토로 설계의 정확도를 높입니다. <br>
                                                분석된 발전량을 기반으로 재생에너지 비율, 투자 회수 기간(ROI) 등 경제성 평가까지 제공하여 최적의 설계 결정을 돕습니다.</p>
                                        </div>
                                    </div>
                                    <div class="boxs_row right">
                                        <div class="box text right">
                                            <span>Establishment of Integrated Energy Systems</span>
                                            <h3>에너지 통합 시스템 구축</h3>
                                            <p>ICT(정보통신기술)를 활용해 하나의 시스템처럼 통합 제어하여 효율을 극대화합니다. <br>
                                                스마트 미터링(AMI)과 IoT 센서를 통해 에너지 사용량과 발전량을 실시간 수집하여 플랫폼에서 시각화하고, 낭비되는 구간을 찾아냅니다. <br><br>
                                                단순히 장비를 설치하는 것을 넘어, 분산된 에너지 자원을 하나의 유기체처럼 움직이게 만드는 종합 엔지니어링 과정입니다.</p>
                                        </div>
                                        <div class="box img">
                                            <img src="@/assets/busi_04.jpg" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="boxs_flx" v-else>
                                    <div class="boxs_row left">
                                        <div class="box img">
                                            <img src="@/assets/busi_05.jpg" alt="">
                                        </div>
                                        <div class="box text">
                                            <span>Integrated Energy & Peak Optimization Consulting</span>
                                            <h3>분산에너지·피크관리·효율화 통합 컨설팅 (진단–제어–M&V–고도화)</h3>
                                            <p>분산에너지를 기반으로 산업 현장의 피크 관리, 에너지 비용 절감, 설비·운영 효율 개선을 설계·지원합니다. <br><br>
                                                도입 전에는 공정·설비별 사용 진단을 통해 신재생·ESS, 고효율 설비, 제어 최적화 적용안을 제시하며, 
                                                도입 후에는 계측·모니터링과 데이터 분석으로 성과를 검증하고 추가 개선 과제를 도출합니다.</p>
                                        </div>
                                    </div>
                                    <div class="boxs_row right">
                                        <div class="box text">
                                            <span>Carbon Offset & GHG Reduction Consulting</span>
                                            <h3>배출권 외부사업·온실가스 감축 컨설팅 (MRV·LCA 대응)</h3>
                                            <p>배출권거래제 기반 외부사업의 기획·운영을 지원하며, 감축사업 타당성 검토부터 사업 구조 설계, 등록·모니터링·사후관리까지 전 과정을 체계적으로 수행합니다.<br><br>
                                            데이터 기반 MRV 체계를 구축해 감축량 산정의 신뢰도를 높이고, 배출권 확보와 운영 리스크를 관리합니다. <br><br>
                                            또한 LCA·제품탄소발자국 대응 방향을 함께 정리해 기업의 탄소중립 목표 달성과 환경 규제 대응을 지원합니다.</p>
                                        </div>
                                        <div class="box img">
                                            <img src="@/assets/busi_06.jpg" alt="">
                                        </div>
                                    </div>
                                    <div class="boxs_row left">
                                        <div class="box img">
                                            <img src="@/assets/busi_07.jpg" alt="">
                                        </div>
                                        <div class="box text">
                                            <span>Strategic Energy Business Development</span>
                                            <h3>대외협력 기반 에너지 신 사업 기획·제안 (실증·확산·사업화)</h3>
                                            <p>기관·기업 수요를 기반으로 신규 사업 기회를 발굴하고, 정책·예산 구조에 맞춘 사업 모델 설계와 제안서 고도화를 지원합니다.<br><br>
                                                실증(PoC) 단계에서 성과지표와 운영 구조를 설계한 후, 파트너·컨소시엄 구성과 재원조달, 확산 전략까지 연계해 사업화 가능한 패키지로 전환합니다.<br><br>
                                                이를 통해 이해관계자 협업을 바탕으로 실행력 있는 에너지 신 사업을 안정적으로 추진합니다.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section section2">
                    <div class="inner_main ptb100">
                        <h2>"BIM-ZENS Platform"</h2>
                        <div class="boxs_flx">
                            <div class="con_box">
                                <h3>BIM - 라이브러리 마켓</h3>
                                <p>실제 제조사 정보를 바탕으로 정교하게 제작된 BIM 라이브러리를 자유롭게 탐색하고 구매하세요. 
                                    프로젝트에 즉시 적용 가능한 표준화된 데이터를 통해 설계의 정확도를 높이고 작업 시간을 획기적으로 
                                    단축할 수 있습니다.</p>
                                <div class="items_row">
                                    <div
                                        class="item"
                                        v-for="item in mainLibraries"
                                        :key="item.id"
                                      >
                                        <img
                                          :src="item.list_img 
                                            ? apiBaseUrl + '/' + item.list_img 
                                            : apiBaseUrl + '/no_photo.jpg'"
                                        >

                                        <div class="bottom">
                                          <h4>{{ item.module_name }}</h4>

                                          <div class="option">
                                            <span><strong>제조사</strong> {{ item.company }}</span>
                                            <span><strong>모델명</strong> {{ item.module_name }}</span>
                                            <span><strong>색상</strong> {{ item.color }}</span>
                                          </div>

                                          <button class="more" @click="goView(item)">
                                            더보기
                                          </button>
                                        </div>
                                      </div>                                    
                                </div>
                                <div class="butt_box">
                                    <button class="buttn" @click="goBimService">서비스 이용하기 →</button>
                                </div>
                            </div>
                            <div class="con_box row">
                                <div class="box img">
                                    <img src="@/assets/busi_08.jpg" alt="">
                                </div>
                                <div class="box text">
                                    <h3>설계 및 시뮬레이션</h3>
                                    <p>태양광 및 BIPV 설계 의뢰를 통해 건축물에 최적화된 배치와 분석 결과를 제공받으세요.  공유된 프로젝트를 바탕으로 실시간 소통이 가능하며, 지속적으로 업데이트되는 예상 발전 효율 및 경제성 분석 보고서를 통해 설치 효과를 면밀히 검토할 수 있습니다.</p>
                                    <button class="buttn" @click="goDesignService">서비스 이용하기 →</button>
                                </div>
                            </div>
                            
                            <div class="con_box row col">
                                <div class="box text">
                                    <h3>유지관리 서비스</h3>
                                    <p>태양광 시설의 안정적인 운영을 위해 검증된 유지관리 전문가와 사용자를 연결해 드립니다. 사용자의 관리·보수 문의를 바탕으로 최적의 유지관리사와 매칭을 지원하며, <br>원활한 계약과 협업이 이뤄질 수 있는 통합 중개 환경을 제공합니다.</p>
                                    <button class="buttn" @click="goMaintenenceService">서비스 이용하기 →</button>
                                </div>
                                <div class="box img">
                                    <img src="@/assets/busi11.png" alt="">
                                </div>
                            </div>

                            <div class="con_box row">
                                <div class="box img">
                                    <img src="@/assets/busi_10.jpg" alt="">
                                </div>
                                <div class="box text">
                                    <h3>ZEB 제조사</h3>
                                    <p>검증된 ZEB 파트너사를 탐색하고, 직접적인 협업 기회를 창출해 보세요. 
                                        제조사 구독 시 귀사의 기술력을 플랫폼 내 최적의 위치에서 홍보하고, 전략적인 프로모션을 통해 비즈니스 영향력을 극대화할 기회를 제공합니다.</p>
                                    <button class="buttn" @click="goZebService">서비스 이용하기 →</button>
                                </div>
                            </div>

                            <div class="con_box plat">
                                <h3>플랫폼 최신 포스트 알아보기</h3>
                                <p>제로에너지건축(ZEB)과 BIM 실무를 위한 전문 기술 지식과 최신 산업 트렌드를 한곳에서 확인하세요. 
                                    에너지넷의 전문 유튜브 영상과 포스트를 통해 플랫폼 활용법부터 핵심 기술 교육까지, 실무에 바로 적용 가능한 인사이트를 제공합니다.</p>
                                <div class="items_row">
                                    <div
                                        class="item"
                                        v-for="(post, index) in mainPosts"
                                        :key="index"
                                      >
                                        <a :href="post.url" target="_blank">
                                          <img
                                            :src="post.img 
                                              ? `${apiBaseUrl}/${post.img}` 
                                              : `${apiBaseUrl}/no_photo.jpg`"
                                          >
                                          <div class="bottom">
                                            <h4>{{ post.title }}</h4>
                                          </div>
                                        </a>
                                      </div>    
                                </div>
                                <div class="butt_box">
                                    <button class="buttn" @click="goPostService">서비스 이용하기 →</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section section3">
                    <div class="inner_main ptb100">
                        <h1>설계부터 유지관리까지, <br>
                            에너지넷이 앞당기는 제로에너지의 미래</h1>
                        <p>BIM 기반의 체계적인 시스템 구축과 전 주기 통합 관리를 경험해 보세요. <br>
                        에너지넷의 솔루션이나 플랫폼 활용에 대해 궁금한 점이 있다면 무엇이든 물어보세요.</p>
                        <div class="butt_box">
                            <button class="buttn" @click="goInquiryService">문의하기 →</button>
                        </div>
                    </div>
                </section>
            </main>
        <TheFooter />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
    name: 'NewMain',  
    data() {
        return {
            activeTab: 1,
            mainLibraries: [],
            mainPosts: []    
        }
    },
    mounted() {
      this.fetchMainData()
    },
    computed: {
      apiBaseUrl() {
        return api.defaults.baseURL || ''
      }
    },
    methods: {
        async fetchMainData() {
            try {
              const res = await api.get('/admin/mainData')

              if (res.data.success && res.data.data?.library) {
                this.mainLibraries = res.data.data.library
              }
              if (res.data.data?.posts) {
                this.mainPosts = res.data.data.posts
              }

            } catch (e) {
              console.error('메인 데이터 불러오기 실패:', e)
            }
          },

      goBimService() {
        this.$router.push('/bim_library_market')
      },
      goDesignService() {
        this.$router.push('/design_simulation')
      },
      goMaintenenceService() {
        this.$router.push('/maintenance')
      },
      goZebService() {
        this.$router.push('/zeb_manufacturer')
      },
      goPostService() {
        this.$router.push('/online_seminar')
      },
      goInquiryService() {
        this.$router.push('/inquire_form')
      },

      goView(item) {
        this.$router.push(`/bim_library_market_view?id=${item.id}`)
      }
    },    
    components: { TheHeader, TheFooter },
}
</script>